import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import cheveux from "images/chev.png";
import COSMETIQUER from "images/cosm.png";
import COMPLEMNT from "images/comp.png";
import packs from "images/packr.png";
import Garence from "images/gar.png";

import "./BioCosmetics.css";

const categories = [
  { key: "Cosmétique", img: COSMETIQUER, route: "/Cosmetique" },
  { key: "Packs", img: packs, route: "/Packs" },
  { key: "Complément", img: COMPLEMNT, route: "/Complements" },
  { key: "Shampoing", img: cheveux, route: "/Shampoing-1l" },
  { key: "Garence", img: Garence, route: "/Garence" },
];

const BioCosmetics = () => {
  const { t } = useTranslation();

  const styles = {
    container: {
      textAlign: "center",
      padding: "40px 20px",
      fontFamily: "'Segoe UI', sans-serif",
      background: "#fff",
      color: "#333",
    },
    heading: {
      color: "#2d5934",
      fontSize: "2.2em",
      marginBottom: "20px",
    },
    description: {
      fontSize: "1em",
      maxWidth: "800px",
      margin: "0 auto 40px",
      color: "#555",
      lineHeight: "1.5",
    },
    grid: {
      display: "flex",
      flexWrap: "nowrap",
      overflowX: "auto",
      gap: "20px",
      justifyContent: "center", // ✅ fixed typo ("justufy-content" → "justifyContent")
    },
    card: {
      flex: "0 0 200px",
      minWidth: "200px",
      padding: "10px",
      textAlign: "center",
      textDecoration: "none",
      borderRadius: "8px",
      transition: "transform 0.3s ease",
      backgroundColor: "#fff",
    },
    image: {
      width: "100%",
      borderRadius: "8px",
    },
    title: {
      margin: "10px 0 5px",
      color: "#2d5934",
      fontSize: "1em",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>{t("bioCosmetics.heading")}</h1>
      <p style={styles.description}>{t("bioCosmetics.description")}</p>

      <div style={styles.grid} className="hide-scroll">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={cat.route}
            style={styles.card}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.03)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          >
            <img
              src={cat.img}
              alt={t(`bioCosmetics.categories.${cat.key}.title`)}
              style={styles.image}
            />
            <h3 style={styles.title}>
              {t(`bioCosmetics.categories.${cat.key}.title`)}
            </h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BioCosmetics;
